/* eslint-disable @next/next/no-img-element */
import Image from "next/image";
import Link from "next/link";
import isEmpty from "lodash/isEmpty";
import parse, { domToReact } from 'html-react-parser';
import { join } from 'lodash';
import { isMobile } from "utilities/helper";

export default function Index({ proInf }) {
    if (isEmpty(proInf)) return;
    const brOrComma = isMobile() ? '<br/>' : ', ';
    const linhVuc = join((proInf.fields?.data || []).map(x => x.name), brOrComma);
    const vaiTro = join((proInf.job_titles?.data || []).map(x => x.name), brOrComma);
    const phongCach = join((proInf.styles?.data || []).map(x => x.name), brOrComma);
    const address = proInf.address
        + (proInf.ward?.name ? `, ${proInf.ward.name}` : '')
        + (proInf.district?.name ? `, ${proInf.district.name}` : '')
        + (proInf.province?.name ? `, ${proInf.province.name}` : '');
    return (
        <>
            <div className="groupCategory-title">
                <h2 className="groupCategory-tlt">Thông tin chuyên gia</h2>
            </div>
            <table className="table-introduce">
                <tbody>
                    {linhVuc && <tr>
                        <th>Lĩnh vực</th>
                        <td className="pc-only">{linhVuc}</td>
                        <td className="sp-only" dangerouslySetInnerHTML={{ __html: linhVuc }}></td>
                    </tr>}
                    {vaiTro && <tr>
                        <th>Vai trò</th>
                        <td className="pc-only">{vaiTro}</td>
                        <td className="sp-only" dangerouslySetInnerHTML={{ __html: vaiTro }}></td>
                    </tr>}
                    {phongCach && <tr>
                        <th>Phong cách</th>
                        <td className="pc-only">{phongCach}</td>
                        <td className="sp-only" dangerouslySetInnerHTML={{ __html: phongCach }}></td>
                    </tr>}
                    {address && <tr>
                        <th>Địa chỉ</th>
                        <td>{address}</td>
                    </tr>}
                    {proInf.phone && <tr>
                        <th>Số điện thoại</th>
                        <td>{proInf.phone}</td>
                    </tr>}
                    {proInf.location && <tr>
                        <th>Phạm vi hoạt động</th>
                        <td>{proInf.location || "Chưa xác định phạm vi hoạt động"}</td>
                    </tr>}
                    {!isEmpty(proInf.achievements?.data) && <tr>
                        <th>Huy hiệu</th>
                        <td>
                            <ul className="list-armorial">
                                {proInf.achievements?.data.map((x, i) => {
                                    return <li key={i}><img width={32} height={32} src={x?.file?.storage_url || "/images/overview-items1.png"} alt={x.name} title={x.name} /></li>;
                                })}
                            </ul>
                        </td>
                    </tr>}
                    <tr>
                        <th>Liên kết</th>
                        <td>
                            <ul className="list-social">
                                {proInf.links?.website && <li>
                                    <Link href={proInf.links.website}>
                                        <a target="_blank">
                                            <Image width={32} height={32} src="/images/social-Website.svg" alt={proInf.links.website} />
                                        </a>
                                    </Link>
                                </li>}
                                {proInf.links?.facebook && <li>
                                    <Link href={proInf.links.facebook}>
                                        <a target="_blank">
                                            <Image width={32} height={32} src="/images/social-Facebook.svg" alt={proInf.links.facebook} />
                                        </a>
                                    </Link>
                                </li>}
                                {proInf.links?.instagram && <li>
                                    <Link href={proInf.links.instagram}>
                                        <a target="_blank">
                                            <Image width={32} height={32} src="/images/social-Instagram.svg" alt={proInf.links.instagram} />
                                        </a>
                                    </Link>
                                </li>}
                                {proInf.links?.youtube && <li>
                                    <Link href={proInf.links.youtube}>
                                        <a target="_blank">
                                            <Image width={32} height={32} src="/images/social-Youtube.svg" alt={proInf.links.youtube} />
                                        </a>
                                    </Link>
                                </li>}
                                {proInf.links?.flickr && <li>
                                    <Link href={proInf.links.flickr}>
                                        <a target="_blank">
                                            <Image width={32} height={32} src="/images/social-Tiktok.svg" alt={proInf.links.flickr} />
                                        </a>
                                    </Link>
                                </li>}
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="groupCategory-title">
                <h2 className="groupCategory-tlt">Mô tả chuyên gia</h2>
            </div>
            <div>
                <p style={{ whiteSpace: 'pre-wrap' }}>{parse(proInf.bio || '')}</p>
            </div>
        </>
    );
}